import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Grid3x2GapFill, House, Diagram3Fill } from 'react-bootstrap-icons';
import SimpleSection from '../../components/SimpleSection';
import AboutLayoutLoading from '../../layouts/AboutLayoutLoading';
import SearchToolbarLoading from '../../components/SearchToolbarLoading';
import LoadingCollectionCard from '../../components/LoadingCollectionCard';
import TreeViewLoading from '../../components/TreeViewLoading';

export default function ISADgCollectionLoading({ isadg }) {
	return (
		<AboutLayoutLoading
			search
			collage
			subtitle={
				isadg.includes('GT-CIRMA-FG')
					? 'Fototeca Guatemala'
					: 'Archivo Histórico'
			}
			subtitleIcon={<House />}
		>
			<SimpleSection className='c-welcome-cirma c-gallery-container'>
				<Container className='cfil'>
					<Row>
						<Col xl={11} sm={11} xs={10}>
							<SearchToolbarLoading />
						</Col>
						<Col xl={1} sm={1} xs={2} className='lyd'>
							<Button
								variant={'light'}
								className='c-tree-button p-0'
							>
								<Grid3x2GapFill />
							</Button>
						</Col>
					</Row>
					<Row className='d-lg-none'>
						<Col>
							<Button
								variant={'light'}
								className='c-tree-button p-0'
							>
								<Diagram3Fill />
							</Button>
						</Col>
					</Row>
				</Container>
				<Container className='d-none ggridv d-lg-block'>
					<Row>
						<Col lg={3}>
							<TreeViewLoading tree={new Array(15).fill('')} />
						</Col>
						<Col lg={9}>
							<Row>
								{new Array(15).fill('').map((_, indx) => (
									<LoadingCollectionCard
										key={`Loading-card-${indx}`}
									/>
								))}
							</Row>
						</Col>
					</Row>
				</Container>
				<Container className='d-block d-lg-none ggridv'>
					<Row>
						<Container>
							<Row>
								{new Array(5).fill('').map((_, indx) => (
									<LoadingCollectionCard
										key={`Loading-card-phone-${indx}`}
									/>
								))}
							</Row>
						</Container>
					</Row>
				</Container>
			</SimpleSection>
		</AboutLayoutLoading>
	);
}
